import _ from 'lodash';

import { apiClient } from '@f/api-client';

import { createAction } from '../actions';
import { localStorageClient } from '../storage/wrapper';

export const ADMINISTRATION_DEBUG_MODE_TOGGLE = 'ADMINISTRATION_DEBUG_MODE_TOGGLE';
export const ADMINISTRATION_DEBUG_DRAWER_SET_OPEN = 'ADMINISTRATION_DEBUG_DRAWER_SET_OPEN';
export const DEBUG_MODE_KEY = 'debug_mode';

export async function findUsers(ids = []) {
  const result = await apiClient.user.fetchUsers({ query: { ids } });

  if (result.status !== 200) {
    throw new Error(result.body);
  }

  return _.keyBy(result.body, 'id');
}

export function toggleDebugMode() {
  return (dispatch, getState) => {
    const state = getState();
    localStorageClient.setItem(DEBUG_MODE_KEY, !state.administration.debug.isDebugModeEnabled);
    dispatch(createAction(ADMINISTRATION_DEBUG_MODE_TOGGLE));
  };
}
